import { render } from "./Foundation.vue?vue&type=template&id=74ffdb14&scoped=true"
import script from "./Foundation.vue?vue&type=script&lang=js"
export * from "./Foundation.vue?vue&type=script&lang=js"

import "./Foundation.vue?vue&type=style&index=0&id=74ffdb14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ffdb14"]])

export default __exports__